import { render, staticRenderFns } from "./UserClauseLibrary.vue?vue&type=template&id=14130e42&scoped=true"
import script from "./UserClauseLibrary.vue?vue&type=script&lang=js"
export * from "./UserClauseLibrary.vue?vue&type=script&lang=js"
import style0 from "./UserClauseLibrary.vue?vue&type=style&index=0&id=14130e42&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14130e42",
  null
  
)

export default component.exports